import UpdateAppointmentStatusDialog from './UpdateAppointmentStatusDialog';

export default UpdateAppointmentStatusDialog;
